/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import Styles from './OpenFinance.css';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import FaqLPs25 from '@/components/molecules/FaqLPs25';
import OpenFinanceBlog from '@/components/organisms/OpenFinanceBlog';
import OpenFinanceBanner from '@/components/organisms/OpenFinanceBanner';
import OpenFinanceOQueE from '@/components/organisms/OpenFinanceOQueE';
import OpenFinanceVantagens from '@/components/organisms/OpenFinanceVantagens';
import OpenFinancePassoAPasso from '@/components/organisms/OpenFinancePassoAPasso';

function OpenFinance() {
  const faqTitle = 'Saiba mais sobre o Open finance';
  const imgpng = 'assets/open-finance/img-perguntas.png';
  const imgwebp = 'assets/open-finance/img-perguntas.webp';
  const imgpngdesk = 'assets/open-finance/img-perguntas-desk.png';
  const imgwebpdesk = 'assets/open-finance/img-perguntas-desk.webp';
  const imgalt =
    'Homem sentada em sofá azul usando laptop, ilustrando o uso do Open Finance Santander para empresas e pessoa física, com foco em segurança, integração bancária, melhores taxas, ofertas personalizadas e portabilidade de crédito.';
  // const linkMostrarTodasPerguntas = 'duvidas-frequentes.html';
  const faqs = [
    {
      pergunta: 'O que é o Open Finance?',
      resposta: `O Open Finance, o Sistema Financeiro Aberto, é a padronização do compartilhamento de dados dos clientes de instituições autorizadas pelo Banco Central.`,
    },
    {
      pergunta: 'O que é o cadastro do Open Finance?',
      resposta: `O cadastro é a autorização que os clientes, pessoa física ou jurídica, podem dar para que uma instituição consiga acessar seus dados de outras instituições`,
    },
    {
      pergunta: 'Como o Open Finance vai impactar a minha vida?',
      resposta: `O Open Finance vai ajudar você a conquistar novas possibilidades como pessoa ou como empresa. Isso porque sua principal característica é oferecer autonomia para você ter mais controle sobre sua vida financeira, gerenciando suas contas e gastos em um único lugar.`,
    },
    {
      pergunta: 'Como faço para cancelar o compartilhamento dos meus dados?',
      resposta: `O cancelamento pode ser solicitado tanto na instituição em que você permitiu o compartilhamento de seus dados, quanto na que disponibilizou suas informações. Para isso, você deve utilizar os canais digitais do banco (aplicativos ou Internet Banking).`,
    },
  ];
  return (
    <>
      <Head>
        <title>Open Finance | Santander Financiamentos</title>
        <meta name="robots" content="index, follow" />
        <link rel="preload" href="assets/canais-de-atendimento/hero/banner-1280.webp" as="image" />
        <meta
          name="Description"
          content="Com o Open Finance Santander, tenha acesso a ofertas de crédito, investimentos e controle financeiro personalizados. Simples, seguro e rápido."
        />
        <meta
          name="keywords"
          content=" Open Finance Santander, Santander Open Finance, compartilhar dados bancários, Segurança Open Finance, melhores ofertas de crédito, Ofertas personalizadas, Redução de juros, melhores taxas, Open Finance Santander para empresas, Open Finance Santander para pessoa física, Portabilidade de crédito, Serviços Open Finance, conectar contas bancárias, Open Banking, Open Finance, o que é open finance, integração bancária open finance "
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/open-finance.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Open Finance | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/open-finance.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Com o Open Finance Santander, tenha acesso a ofertas de crédito, investimentos e controle financeiro personalizados. Simples, seguro e rápido."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/open-finance/hero/banner-1360.webp"
        />
        <meta
          property="og:image:alt"
          content="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Open Finance | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Com o Open Finance Santander, tenha acesso a ofertas de crédito, investimentos e controle financeiro personalizados. Simples, seguro e rápido."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/open-finance.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/open-finance/hero/banner-1360.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 isHome24 />
      <OpenFinanceBanner />
      <OpenFinanceOQueE />
      <OpenFinanceVantagens />
      <OpenFinancePassoAPasso />
      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        // linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <OpenFinanceBlog />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default OpenFinance;
